module.exports = __webpack_public_path__ + "static/media/favorites-filled-red.5807fa17.svg";